import { ChevronDown } from '@app/components/various/Icons';
import { cn } from '@app/utils/cn';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { getExpanderRowId } from '../helpers';

interface ExpanderCellProps {
  onExpand?: VoidFunction;
  expanded?: boolean;
  rowId: string;
  className?: string;
}

export const ExpanderCell = ({ onExpand, expanded, rowId, className }: ExpanderCellProps) => {
  const { t } = useTranslation(['common']);

  return (
    <button
      className={cn('relative m-auto rounded-full after:absolute after:-inset-3', className)}
      aria-label={t('common:expand_row')}
      onClick={onExpand}
      aria-expanded={expanded}
      aria-controls={getExpanderRowId(rowId)}
    >
      <ChevronDown className={cx('motion-safe:transition-transform', { '-rotate-180': expanded })} />
    </button>
  );
};
